/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  gray_10: '#f5f7fa',
  gray_20: '#ebeff5',
  gray_30: '#dde3ed',
  gray_40: '#c8d1e0',
  gray_50: '#afbacc',
  gray_60: '#8e99ab',
  gray_70: '#707a8a',
  gray_80: '#58606e',
  gray_90: '#434a54',
  gray_100: '#333840',

  a11y_text_light: [80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/gray.js